document.addEventListener("DOMContentLoaded", function() {
    const selectors = document.querySelectorAll('.section-dropdown');
    const close_all = document.querySelector('#landing-closeall-trigger');
    if(selectors.length > 0){
        triggerDropdown(selectors);
    }
   
    if(close_all){        
        triggerCloseAll(close_all);
    }    
});

function triggerDropdown(selectors){
    selectors.forEach(selector => {
        var relation = selector.getAttribute('id');
        var contents = document.querySelectorAll('.dropdown-content[rel="'+relation+'"]');
        var open = selector.querySelector('a');  
        var close = selector.querySelector('.close-dropdown'); 
                        
        if(contents.length > 0){
            
            open.addEventListener('click', (e) => {
                e.preventDefault();              
                contents.forEach(content => {                                                 
                        document.querySelectorAll(".section-dropdown").forEach(el => el.classList.remove('open'));
                        document.querySelectorAll(".dropdown-content").forEach(el => el.classList.remove('open'));
                        setTimeout(function(){ 
                            content.classList.add("open");
                            selector.classList.add("open");
                            document.querySelectorAll(".section-dropdown:not(.open)").forEach(el => el.classList.add('hidden'));                           
                         }, 400);                                              
                });                                   
            });   
            
            close.addEventListener('click', (e) => {
                e.preventDefault();              
                contents.forEach(content => {     
                        document.querySelectorAll(".section-dropdown").forEach(el => el.classList.remove('open'));
                        document.querySelectorAll(".section-dropdown").forEach(el => el.classList.remove('hidden'));
                        document.querySelectorAll(".dropdown-content").forEach(el => el.classList.remove('open'));
                });   
            });  
        }
    });
}

function triggerCloseAll(trigger){    
    trigger.addEventListener('click', (e) => {        
        e.preventDefault();              
        document.querySelectorAll(".section-dropdown").forEach(el => el.classList.remove('open' ,'hidden'));        
        document.querySelectorAll(".dropdown-content").forEach(el => el.classList.remove('open')); 

        if(document.querySelectorAll(".section-dropdown").length > 0){            
            var first = document.querySelectorAll(".section-dropdown")[0];        
            first.scrollIntoView();
        }               
    });  
}